import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Card, ProgressBar } from "react-bootstrap";
import Person from "../../assets/images/person.svg";
import Truck from "../../assets/images/truck.svg";
import Courier from "../../assets/images/courier.svg";
import {
  getAvgPerDayApi,
  getCountApi,
  getMonthAttenApi,
  getIncommerApi,
  getTodayAttenApi,
} from "./gate-api";
import { useGlobal } from "../../GlobalContext";

const GateDashboard = ({
  interval = 10,
  widgets = [
    /* {
      id: 1,
      name: "Count details",
      seq_no: 2,
      status: true,
    },
    {
      id: 2,
      name: "Total incomers",
      seq_no: 1,
      status: true,
    },
    {
      id: 3,
      name: "Today attendance",
      seq_no: 3,
      status: true,
    },
    {
      id: 4,
      name: "Average gate in activities",
      seq_no: 1,
      status: true,
    },
    {
      id: 5,
      name: "Monthly attendance",
      seq_no: 1,
      status: true,
    }, */
  ],
}) => {
  const { dashboardToken } = useGlobal();
  // let dashboardToken =
  //   "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vc2lnbmFnZS92MS9hcGkvZGV2aWNlIiwiaWF0IjoxNzUyNjUyMjI1LCJleHAiOjE3ODQxODgyMjUsIm5iZiI6MTc1MjY1MjIyNSwianRpIjoiVElTUHdWMDQydlBwdkswYyIsInN1YiI6IjMxIiwicHJ2IjoiYjkwZjcxZjJiMDQ2ZjM1NDJhMDI3ODEwODllYTc1NjY4ZmUzYWU2MyIsImF1dGhpZCI6NDIxLCJvcmdpZCI6MTAwLCJ1c2VyaWQiOjQyMSwiZGF0YWJhc2VuYW1lIjoicmFndXJyIiwib3JnX2NvZGUiOiJyYWd1cnIiLCJ0aW1lem9uZSI6IiIsInJvbGVpZCI6NDAxLCJwYXltZW50X3N0YXR1cyI6dHJ1ZSwiYXV0aG9yaXRpZXMiOlsiUk9MRV9VU0VSIl0sImRldmljZUlkIjozMSwiZ3JvdXBJZCI6MjksInNpZ25hZ2VfY29kZSI6IiJ9.8TbS6NGX1IKhux_Y1QSqyMq9Qrr7sqKg--HuOMHpzIo";

  const intervalRef = useRef(null);
  const [averagePerDay, setaveragePerDay] = useState({});
  const [countVisitor, setcountVisitor] = useState({});
  const [countVehicle, setcountVehicle] = useState({});
  const [countCoruier, setcountCoruier] = useState({});
  const [todayvisitors, settodayvisitors] = useState({});
  const [todayvehicle, settodayvehicle] = useState({});
  const [todayCourier, settodayCourier] = useState({});
  const [monthAttand, setmonthAttand] = useState([]);
  const [overallIncomer, setOverallIncomer] = useState({});
  const value = 40;
  const [sortedWidgetList, setSortedWidgetList] = useState([]);
  useEffect(() => {
    setSortedWidgetList([...widgets].sort((a, b) => a.seq_no - b.seq_no));
  }, []);
  // useEffect(() => {
  //     console.log('interval...gt.......', interval)

  // }, []);

  const callAllAPIs = () => {
    getCountDetails();
    getAvgPerDayDetails();
    getTodayAttenDetails();
    getMonthAttenDetails();
    getOverallIncomerApiDetails();
  };
  useEffect(() => {
    // Initial API call
    callAllAPIs();

    // Setup interval
    intervalRef.current = setInterval(() => {
      callAllAPIs();
    }, interval * 1000); // convert seconds to ms

    // Cleanup on unmount
    return () => clearInterval(intervalRef.current);
  }, [interval]);
  const getAvgPerDayDetails = async () => {
    const response = await getAvgPerDayApi(dashboardToken);
    console.log("response....");

    if (response.data.status === true) {
      setaveragePerDay(response.data.averagePerDay ?? {});
    }
  };
  const getCountDetails = async () => {
    const response = await getCountApi(dashboardToken);
    console.log("response....");

    if (response.data.status === true) {
      setcountVisitor(response.data.count.visitors ?? {});
      setcountVehicle(response.data.count.vehicles ?? {});
      setcountCoruier(response.data.count.couriers ?? {});
    }
  };
  const getTodayAttenDetails = async () => {
    const response = await getTodayAttenApi(dashboardToken);
    console.log("response....");

    if (response.data.status === true) {
      settodayvisitors(response.data.TodayAttandence.visitors ?? {});
      settodayvehicle(response.data.TodayAttandence.vehicle ?? {});
      settodayCourier(response.data.TodayAttandence.courier ?? {});
    }
  };
  const getMonthAttenDetails = async () => {
    const response = await getMonthAttenApi(dashboardToken);
    console.log("response....");

    if (response.data.status === true) {
      setmonthAttand(response.data.MonthlyAttandence ?? []);
    }
  };
  const getOverallIncomerApiDetails = async () => {
    const response = await getIncommerApi(dashboardToken);
    console.log("response....");

    if (response.data.status === true) {
      setOverallIncomer(response.data.OverallIncomers);
    }
  };

  const fontResize = (baseFont, percentage) => {
    const fontSize = baseFont * (1 + percentage / 100);
    return fontSize;
  };

  const countDetailsWidget = () => {
    const index = widgets.findIndex(
      (widget) => widget.name === "Count details" && widget.status === true
    );
    var fontPercentage = 0;
    if (index > -1) {
      if (widgets[index].width === "custom") {
        fontPercentage = widgets[index].width_size ?? 0;
      } else if (widgets[index].width === "large") {
        fontPercentage = 30;
      } else if (widgets[index].width === "medium") {
        fontPercentage = 0;
      } else if (widgets[index].width === "small") {
        fontPercentage = -20;
      }
    }
    return (
      widgets.some(
        (widget) => widget.name === "Count details" && widget.status === true
      ) && (
        <Col md={8}>
          <Row>
            <Col md={4} style={{ width: "22vw", gap: "-10px" }}>
              <div
                style={{
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "0 0 10px rgba(0,0,0,0.05)",
                  marginBottom: "15px",
                  backgroundColor: "#fff",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    justifyContent: "space-between",
                  }}
                >
                  <img
                    src={Person}
                    alt="Visitors"
                    style={{
                      width: "52px",
                      height: "52px",
                      borderRadius: "14px",
                      padding: "15px",
                      backgroundColor: "#F0F4FF",
                      objectFit: "cover",
                    }}
                  />
                  <div
                    style={{
                      fontSize: `${fontResize(22, fontPercentage)}px`,
                      fontWeight: "600",
                    }}
                  >
                    {countVisitor.total ?? 0}
                  </div>
                  <div
                    style={{
                      fontSize: `${fontResize(12, fontPercentage)}px`,
                      color: "#777",
                    }}
                  >
                    Visitors
                  </div>
                </div>

                <ProgressBar
                  now={80}
                  style={{
                    height: "6px",
                    margin: "15px 0",
                    backgroundColor: "#E9ECEF",
                  }}
                >
                  <div
                    style={{
                      width: `${countVisitor.Difference / countVisitor.total}%`,
                      height: "100%",
                      backgroundColor: "#9D4BF5",
                      borderRadius: "0.25rem",
                    }}
                  />{" "}
                </ProgressBar>

                <div
                  style={{
                    fontSize: `${fontResize(12, fontPercentage)}px`,
                    color: "#0D283E",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "5px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "400",
                      color:
                        countVisitor.differenceValue === "lesser"
                          ? "#FF4D4F"
                          : "#29FF98",
                    }}
                  >
                    {countVisitor.Percentage ?? 0}%
                  </span>
                  {countVisitor.differenceValue === "lesser"
                    ? "decreased"
                    : "increased"}{" "}
                  from last month
                  <span
                    style={{
                      color:
                        countVisitor.differenceValue === "lesser"
                          ? "#FF4D4F"
                          : "#29FF98",
                      marginLeft: "5px",
                      fontWeight: "400",
                    }}
                  >
                    {countVisitor.differenceValue === "lesser" ? "↓" : "↑"}{" "}
                    {countVisitor.Difference ?? 0}
                  </span>
                </div>

                <div
                  style={{
                    marginTop: "12px",
                    fontSize: `${fontResize(12, fontPercentage)}px`,
                    color: "#0D283E",
                  }}
                >
                  Average intime duration
                </div>
                <div
                  style={{
                    fontSize: `${fontResize(16, fontPercentage)}px`,
                    fontWeight: "600",
                  }}
                >
                  {countVisitor.InTimeaverage ?? 0}
                </div>
              </div>
            </Col>
            <Col md={4} style={{ width: "22vw" }}>
              <div
                style={{
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "0 0 10px rgba(0,0,0,0.05)",
                  marginBottom: "15px",
                  backgroundColor: "#fff",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    justifyContent: "space-between",
                  }}
                >
                  <img
                    src={Truck}
                    alt="Truck"
                    style={{
                      width: "52px",
                      height: "52px",
                      borderRadius: "14px",
                      padding: "15px",
                      backgroundColor: "#F0F4FF",
                      objectFit: "cover",
                    }}
                  />
                  <div
                    style={{
                      fontSize: `${fontResize(22, fontPercentage)}px`,
                      fontWeight: "600",
                    }}
                  >
                    {countVehicle.total ?? 0}
                  </div>
                  <div
                    style={{
                      fontSize: `${fontResize(12, fontPercentage)}px`,
                      color: "#777",
                    }}
                  >
                    Vehicles
                  </div>
                </div>

                <ProgressBar
                  now={70}
                  style={{
                    height: "6px",
                    margin: "15px 0",
                    backgroundColor: "#E9ECEF",
                  }}
                >
                  <div
                    style={{
                      width: `${countVehicle.Difference / countVehicle.total}%`,
                      height: "100%",
                      backgroundColor: "#9D4BF5",
                      borderRadius: "0.25rem",
                    }}
                  />{" "}
                </ProgressBar>

                <div
                  style={{
                    fontSize: `${fontResize(11, fontPercentage)}px`,
                    color: "#0D283E",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "5px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "400",
                      color:
                        countVehicle.differenceValue === "lesser"
                          ? "#FF4D4F"
                          : "#29FF98",
                    }}
                  >
                    {countVehicle.Percentage ?? 0}%
                  </span>
                  {countVehicle.differenceValue === "lesser"
                    ? "decreased"
                    : "increased"}{" "}
                  from last month
                  <span
                    style={{
                      color:
                        countVehicle.differenceValue === "lesser"
                          ? "#FF4D4F"
                          : "#29FF98",
                      marginLeft: "5px",
                      fontWeight: "400",
                    }}
                  >
                    {countVehicle.differenceValue === "lesser" ? "↓" : "↑"}{" "}
                    {countVehicle.Difference ?? 0}
                  </span>
                </div>

                <div
                  style={{
                    marginTop: "12px",
                    fontSize: `${fontResize(12, fontPercentage)}px`,
                    color: "#0D283E",
                  }}
                >
                  Average intime duration
                </div>
                <div
                  style={{
                    fontSize: `${fontResize(16, fontPercentage)}px`,
                    fontWeight: "600",
                  }}
                >
                  {countVehicle.InTimeaverage ?? 0}
                </div>
              </div>
            </Col>
            <Col md={4} style={{ width: "22vw" }}>
              <div
                style={{
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "0 0 10px rgba(0,0,0,0.05)",
                  marginBottom: "15px",
                  backgroundColor: "#fff",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    justifyContent: "space-between",
                  }}
                >
                  <img
                    src={Courier}
                    alt="Visitors"
                    style={{
                      height: "52px",
                      borderRadius: "14px",
                      padding: "15px",
                      backgroundColor: "#F0F4FF",
                      objectFit: "cover",
                    }}
                  />
                  <div
                    style={{
                      fontSize: `${fontResize(22, fontPercentage)}px`,
                      fontWeight: "600",
                    }}
                  >
                    {countCoruier.total ?? 0}
                  </div>
                  <div
                    style={{
                      fontSize: `${fontResize(12, fontPercentage)}px`,
                      color: "#777",
                    }}
                  >
                    Couriers
                  </div>
                </div>

                <ProgressBar
                  now={40}
                  style={{
                    height: "6px",
                    margin: "15px 0",
                    backgroundColor: "#E9ECEF",
                  }}
                >
                  <div
                    style={{
                      width: `${countCoruier.Difference / countCoruier.total}%`,
                      height: "100%",
                      backgroundColor: "#9D4BF5",
                      borderRadius: "0.25rem",
                    }}
                  />{" "}
                </ProgressBar>

                <div
                  style={{
                    fontSize: `${fontResize(11, fontPercentage)}px`,
                    color: "#0D283E",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "5px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "400",
                      color:
                        countCoruier.differenceValue === "lesser"
                          ? "#FF4D4F"
                          : "#29FF98",
                    }}
                  >
                    {countCoruier.Percentage ?? 0}%
                  </span>
                  {countCoruier.differenceValue === "lesser"
                    ? "decreased"
                    : "increased"}{" "}
                  from last month
                  <span
                    style={{
                      color:
                        countCoruier.differenceValue === "lesser"
                          ? "#FF4D4F"
                          : "#29FF98",
                      marginLeft: "5px",
                      fontWeight: "400",
                    }}
                  >
                    {countCoruier.differenceValue === "lesser" ? "↓" : "↑"}{" "}
                    {countCoruier.Difference ?? 0}
                  </span>
                </div>

                <div
                  style={{
                    marginTop: "12px",
                    fontSize: `${fontResize(12, fontPercentage)}px`,
                    color: "#0D283E",
                  }}
                >
                  Average intime duration
                </div>
                <div
                  style={{
                    fontSize: `${fontResize(16, fontPercentage)}px`,
                    fontWeight: "600",
                  }}
                >
                  {countCoruier.InTimeaverage ?? 0}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      )
    );
  };

  const totalIncomerWidget = () => {
    const index = widgets.findIndex(
      (widget) => widget.name === "Total incomers" && widget.status === true
    );
    var fontPercentage = 0;
    if (index > -1) {
      if (widgets[index].width === "custom") {
        fontPercentage = widgets[index].width_size ?? 0;
      } else if (widgets[index].width === "large") {
        fontPercentage = 30;
      } else if (widgets[index].width === "medium") {
        fontPercentage = 0;
      } else if (widgets[index].width === "small") {
        fontPercentage = -20;
      }
    }

    return (
      widgets.some(
        (widget) => widget.name === "Total incomers" && widget.status === true
      ) && (
        <Col md={4}>
          <div
            style={{
              padding: "15px",
              borderRadius: "12px",
              boxShadow: "0 0 10px rgba(0,0,0,0.05)",
              marginBottom: "15px",
              backgroundColor: "#fff",
            }}
          >
            <Row style={{ alignItems: "center" }}>
              <div
                style={{
                  fontSize: `${fontResize(16, fontPercentage)}px`,
                  fontWeight: 600,
                  color: "#0D283E",
                }}
              >
                Total Incomers
              </div>
              {/* Left section */}
              <Col md={4}>
                <div
                  style={{
                    fontSize: `${fontResize(32, fontPercentage)}px`,
                    fontWeight: 700,
                  }}
                >
                  {overallIncomer.totalIncomer ?? 0}
                </div>
                <div
                  style={{
                    fontSize: `${fontResize(13, fontPercentage)}px`,
                    marginTop: "8px",
                    color:
                      overallIncomer.differenceValue === "lesser"
                        ? "#f44444"
                        : "#29FF98",
                    fontWeight: "500",
                  }}
                >
                  {overallIncomer.differenceValue === "lesser" ? "↓" : "↑"}{" "}
                  {overallIncomer.Percentage ?? 0}%
                  <span style={{ color: "#0D283E" }}>
                    {overallIncomer.differenceValue === "lesser"
                      ? " decreased"
                      : " increased"}{" "}
                    from last month
                  </span>
                </div>
              </Col>

              {/* Right section */}
              <Col md={8} style={{}}>
                <Row style={{ gap: "0px" }}>
                  <Col
                    xs={6}
                    style={{
                      backgroundColor: "#F5F7F9",
                      padding: "10px 5px 10px 10px",
                      fontWeight: 400,
                      borderRadius: "8px",
                      fontSize: `${fontResize(12, fontPercentage)}px`,
                      marginLeft: "-10px",
                      marginRight: "-5px",
                    }}
                  >
                    <div
                      style={{
                        color: "#707D88",
                        fontSize: `${fontResize(11, fontPercentage)}px`,
                      }}
                    >
                      Min. intime duration
                    </div>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: `${fontResize(15, fontPercentage)}px`,
                        marginTop: "4px",
                      }}
                    >
                      {overallIncomer.minTimeDuration ?? 0}s
                    </div>
                  </Col>
                  <Col
                    xs={6}
                    style={{
                      backgroundColor: "#F5F7F9",
                      padding: "10px 5px 10px 10px",
                      borderRadius: "8px",
                      fontSize: `${fontResize(12, fontPercentage)}px`,
                      marginLeft: "10px",
                    }}
                  >
                    <div
                      style={{
                        color: "#707D88",
                        fontSize: `${fontResize(11, fontPercentage)}px`,
                      }}
                    >
                      Min. intime duration
                    </div>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: `${fontResize(15, fontPercentage)}px`,
                        marginTop: "4px",
                      }}
                    >
                      {overallIncomer.maxTimeDuration ?? 0}s
                    </div>
                  </Col>
                  <Col
                    xs={12}
                    style={{
                      backgroundColor: "#F5F7F9",
                      padding: "10px",
                      borderRadius: "8px",
                      fontSize: `${fontResize(12, fontPercentage)}px`,
                      marginLeft: "-10px",
                      marginTop: "8px",
                    }}
                  >
                    <div style={{ color: "#707D88" }}>Average duration</div>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: `${fontResize(15, fontPercentage)}px`,
                        marginTop: "4px",
                      }}
                    >
                      {overallIncomer.AvgInTimeDuration ?? 0}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
      )
    );
  };

  const todayAttendanceWidget = () => {
    const index = widgets.findIndex(
      (widget) => widget.name === "Today attendance" && widget.status === true
    );
    var fontPercentage = 0;
    if (index > -1) {
      if (widgets[index].width === "custom") {
        fontPercentage = widgets[index].width_size ?? 0;
      } else if (widgets[index].width === "large") {
        fontPercentage = 30;
      } else if (widgets[index].width === "medium") {
        fontPercentage = 0;
      } else if (widgets[index].width === "small") {
        fontPercentage = -20;
      }
    }
    return (
      widgets.some(
        (widget) => widget.name === "Today attendance" && widget.status === true
      ) && (
        <Col
          lg={8}
          style={{
            backgroundColor: "#FFFFFF",
            borderRadius: "14px",
            padding: "10px",
          }}
        >
          <Row style={{ paddingBottom: "10px" }}>
            <div
              style={{
                fontWeight: 600,
                fontSize: `${fontResize(16, fontPercentage)}px`,
                padding: "10px",
              }}
            >
              Today Attendance
            </div>

            <Col md={4} style={{ borderRight: "0.4px solid #E9EBED" }}>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  padding: "20px 20px",
                  alignItems: "center",
                  backgroundColor: "#F5F7F9",
                  borderRadius: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    borderRight: "1px solid #CDCDCD",
                    paddingRight: "20px",
                  }}
                >
                  <span
                    style={{
                      fontSize: `${fontResize(36, fontPercentage)}px`,
                      fontWeight: 400,
                      color: "#0D283E",
                    }}
                  >
                    {todayvisitors.Totalvisitor ?? 0}
                  </span>
                  <span
                    style={{
                      fontSize: `${fontResize(13, fontPercentage)}px`,
                      fontWeight: 400,
                      color: "#707D88",
                      marginLeft: "5px",
                    }}
                  >
                    Visitors
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "4px",
                          backgroundColor: "#9D4BF5",
                        }}
                      ></span>
                      <span
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          fontWeight: 400,
                          color: "#0D283E",
                        }}
                      >
                        Out
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        fontWeight: 700,
                        color: "#0D283E",
                      }}
                    >
                      {todayvisitors.visitorGateout ?? 0}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "4px",
                          backgroundColor: "#29FF98",
                        }}
                      ></span>
                      <span
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          fontWeight: 400,
                          color: "#0D283E",
                        }}
                      >
                        In
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        fontWeight: 700,
                        color: "#0D283E",
                      }}
                    >
                      {todayvisitors.visitorGatein ?? 0}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} style={{ borderRight: "0.4px solid #E9EBED" }}>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  padding: "20px 20px",
                  alignItems: "center",
                  backgroundColor: "#F5F7F9",
                  borderRadius: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    borderRight: "1px solid #CDCDCD",
                    paddingRight: "20px",
                  }}
                >
                  <span
                    style={{
                      fontSize: `${fontResize(36, fontPercentage)}px`,
                      fontWeight: 400,
                      color: "#0D283E",
                    }}
                  >
                    {todayvehicle.Totalvehicle ?? 0}
                  </span>
                  <span
                    style={{
                      fontSize: `${fontResize(13, fontPercentage)}px`,
                      fontWeight: 400,
                      color: "#707D88",
                      marginLeft: "5px",
                    }}
                  >
                    Vehicles
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "4px",
                          backgroundColor: "#9D4BF5",
                        }}
                      ></span>
                      <span
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          fontWeight: 400,
                          color: "#0D283E",
                        }}
                      >
                        Out
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        fontWeight: 700,
                        color: "#0D283E",
                      }}
                    >
                      {todayvehicle.vehicleGateout ?? 0}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "4px",
                          backgroundColor: "#29FF98",
                        }}
                      ></span>
                      <span
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          fontWeight: 400,
                          color: "#0D283E",
                        }}
                      >
                        In
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        fontWeight: 700,
                        color: "#0D283E",
                      }}
                    >
                      {todayvehicle.vehicleGatein ?? 0}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  padding: "20px 20px",
                  alignItems: "center",
                  backgroundColor: "#F5F7F9",
                  borderRadius: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    borderRight: "1px solid #CDCDCD",
                    paddingRight: "20px",
                  }}
                >
                  <span
                    style={{
                      fontSize: `${fontResize(36, fontPercentage)}px`,
                      fontWeight: 400,
                      color: "#0D283E",
                    }}
                  >
                    {todayCourier.Totalcourier ?? 0}
                  </span>
                  <span
                    style={{
                      fontSize: `${fontResize(13, fontPercentage)}px`,
                      fontWeight: 400,
                      color: "#707D88",
                      marginLeft: "5px",
                    }}
                  >
                    Couriers
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "4px",
                          backgroundColor: "#9D4BF5",
                        }}
                      ></span>
                      <span
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          fontWeight: 400,
                          color: "#0D283E",
                        }}
                      >
                        Out
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        fontWeight: 700,
                        color: "#0D283E",
                      }}
                    >
                      {todayCourier.courierGateout ?? 0}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "4px",
                          backgroundColor: "#29FF98",
                        }}
                      ></span>
                      <span
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          fontWeight: 400,
                          color: "#0D283E",
                        }}
                      >
                        In
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        fontWeight: 700,
                        color: "#0D283E",
                      }}
                    >
                      {todayCourier.courierGatein ?? 0}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      )
    );
  };
  const averageGateActivitiesWidget = () => {
    const index = widgets.findIndex(
      (widget) =>
        widget.name === "Average gate in activities" && widget.status === true
    );
    var fontPercentage = 0;
    if (index > -1) {
      if (widgets[index].width === "custom") {
        fontPercentage = widgets[index].width_size ?? 0;
      } else if (widgets[index].width === "large") {
        fontPercentage = 30;
      } else if (widgets[index].width === "medium") {
        fontPercentage = 0;
      } else if (widgets[index].width === "small") {
        fontPercentage = -20;
      }
    }
    return (
      widgets.some(
        (widget) =>
          widget.name === "Average gate in activities" && widget.status === true
      ) && (
        <Col
          lg={4}
          style={{
            backgroundColor: "#FFFFFF",
            padding: "10px",
            borderRadius: "14px",
            width: "fit-content",
          }}
        >
          <div
            style={{
              fontWeight: 600,
              fontSize: `${fontResize(16, fontPercentage)}px`,
              padding: "10px",
            }}
          >
            Average gate in activities per day :
          </div>

          <div
            style={{
              borderRadius: "12px",
              padding: "10px",
              width: "410px",
              margin: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                borderTop: "1px solid transparent",
              }}
            >
              <div
                style={{
                  flex: 1,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: `${fontResize(14, fontPercentage)}px`,
                    color: "#777",
                    marginBottom: "5px",
                  }}
                >
                  Visitors
                </div>
                <div
                  style={{
                    fontSize: `${fontResize(28, fontPercentage)}px`,
                    fontWeight: "700",
                    color: "#1b2e4b",
                  }}
                >
                  {averagePerDay.visitor ?? 0}
                </div>
              </div>
              <div
                style={{
                  width: "1px",
                  backgroundColor: "#e0e0e0",
                  margin: "0 10px",
                }}
              ></div>
              <div
                style={{
                  flex: 1,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: `${fontResize(14, fontPercentage)}px`,
                    color: "#777",
                    marginBottom: "5px",
                  }}
                >
                  Vehicles
                </div>
                <div
                  style={{
                    fontSize: `${fontResize(28, fontPercentage)}px`,
                    fontWeight: "700",
                    color: "#1b2e4b",
                  }}
                >
                  {averagePerDay.vehicle ?? 0}
                </div>
              </div>
              <div
                style={{
                  width: "1px",
                  backgroundColor: "#e0e0e0",
                  margin: "0 10px",
                }}
              ></div>
              <div
                style={{
                  flex: 1,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: `${fontResize(14, fontPercentage)}px`,
                    color: "#777",
                    marginBottom: "5px",
                  }}
                >
                  Couriers
                </div>
                <div
                  style={{
                    fontSize: `${fontResize(28, fontPercentage)}px`,
                    fontWeight: "700",
                    color: "#1b2e4b",
                  }}
                >
                  {averagePerDay.courier ?? 0}
                </div>
              </div>
            </div>
          </div>
        </Col>
      )
    );
  };
  const monthlyAttendanceWidget = () => {
    const index = widgets.findIndex(
      (widget) => widget.name === "Monthly attendance" && widget.status === true
    );
    var fontPercentage = 0;
    if (index > -1) {
      if (widgets[index].width === "custom") {
        fontPercentage = widgets[index].width_size ?? 0;
      } else if (widgets[index].width === "large") {
        fontPercentage = 30;
      } else if (widgets[index].width === "medium") {
        fontPercentage = 0;
      } else if (widgets[index].width === "small") {
        fontPercentage = -20;
      }
    }
    return (
      widgets.some(
        (widget) =>
          widget.name === "Monthly attendance" && widget.status === true
      ) && (
        <div
          style={{
            padding: "10px",
            backgroundColor: "#FFFFFF",
            borderRadius: "14px",
            margin: "10px",
          }}
        >
          <div
            style={{
              fontWeight: 600,
              fontSize: `${fontResize(16, fontPercentage)}px`,
              marginBottom: "10px",
            }}
          >
            Monthly Attendance
          </div>
          <Row>
            {monthAttand.map((month, i) => (
              <Col xs={6} md={3} lg={2} key={i}>
                <Card
                  style={{
                    borderRadius: "12px",
                    padding: "20px",
                    backgroundColor: "#F5F7F9",
                    maxWidth: "250px",
                    margin: "auto",
                    marginBottom: "15px",
                    border: "none",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "700",
                      color: "#0D283E",
                      fontSize: `${fontResize(12, fontPercentage)}px`,
                    }}
                  >
                    {month.hover_period ?? ""}
                  </div>
                  <hr style={{ marginTop: "8px", marginBottom: "16px" }} />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "12px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          width: "12px",
                          height: "12px",
                          backgroundColor: "#FF8C22",
                          borderRadius: "3px",
                          marginRight: "10px",
                        }}
                      ></span>
                      <span
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          color: "#0D283E",
                          fontWeight: 400,
                        }}
                      >
                        Visitors
                      </span>
                    </div>
                    <strong
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#1d2b4f",
                        fontWeight: 700,
                      }}
                    >
                      {month.visitors_count ?? 0}
                    </strong>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "12px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          width: "12px",
                          height: "12px",
                          backgroundColor: "#c823ff",
                          borderRadius: "3px",
                          marginRight: "10px",
                        }}
                      ></span>
                      <span
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          color: "#0D283E",
                          fontWeight: 400,
                        }}
                      >
                        Vehicles
                      </span>
                    </div>
                    <strong
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#1d2b4f",
                        fontWeight: 700,
                      }}
                    >
                      {month.vehicles_count ?? 0}
                    </strong>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          width: "12px",
                          height: "12px",
                          backgroundColor: "#5ca6c6",
                          borderRadius: "3px",
                          marginRight: "10px",
                        }}
                      ></span>
                      <span
                        style={{
                          fontSize: `${fontResize(12, fontPercentage)}px`,
                          color: "#0D283E",
                          fontWeight: 400,
                        }}
                      >
                        Couriers
                      </span>
                    </div>
                    <strong
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#1d2b4f",
                        fontWeight: 700,
                      }}
                    >
                      {month.courier_count ?? 0}
                    </strong>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      )
    );
  };

  return (
    <Container
      fluid
      className="px-0"
      style={{ backgroundColor: "#F5F7F9", paddingBottom: "10px" }}
    >
      <div
        style={{
          padding: "14px 16px",
          fontWeight: "700",
          fontSize: "16px",
          color: "#0D283E",
          backgroundColor: "#FFFFFF",
          borderBottom: "1px solid #CDCDCD",
        }}
      >
        Gate overview dashboard
      </div>
      {sortedWidgetList?.map((widget, i) => {
        if (widget.name === "Count details") {
          return (
            <Row style={{ padding: "10px" }}>
              {countDetailsWidget()}
              {totalIncomerWidget()}
            </Row>
          );
        } else if (widget.name === "Today attendance") {
          return (
            <Row style={{ padding: "10px", margin: "0", gap: "8px" }}>
              {todayAttendanceWidget()}
              {averageGateActivitiesWidget()}
            </Row>
          );
        } else if (widget.name === "Monthly attendance") {
          return monthlyAttendanceWidget();
        } else {
        }
      })}
    </Container>
  );
};

export default GateDashboard;
